import { SerializedError } from '@reduxjs/toolkit'
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query'
import { Link } from 'react-router-dom'
import { CargaInfo } from '../../../../components/layout/CargaInfo'
import { Autorizacion } from '../../models'

type Props = {
  isModoEditar: boolean
  isSuccess: boolean
  autorizacion?: Autorizacion
  idAutorizacion?: string
  isLoading: boolean
  isError: boolean
  error?: FetchBaseQueryError | SerializedError
  usuarioPermiso?: boolean
}
export const EncabezadoAutorizacionForm = ({
  isModoEditar,
  isSuccess,
  autorizacion,
  idAutorizacion,
  isLoading,
  isError,
  error,
  usuarioPermiso,
}: Props) => {
  // Encabezado reutilizado para alta/edicion.
  // Cuando el usuario no tiene permiso de edicion, el formulario se presenta en modo lectura.
  return (
    <>
      <div className='col-12 d-flex justify-content-between'>
        <div className='mt-2 pb-2 d-flex align-items-center' style={{ marginBottom: '20px' }}>
          {isModoEditar ? (
            isSuccess && (
              <>
                <h2>{usuarioPermiso ? 'Editar autorización' : 'Información de la autorización'}</h2>{' '}
                <div className='subheader-separator subheader-separator-ver mx-5 bg-gray-500'></div>
                <h4 className='mr-1 fw-light'>{autorizacion?.descAutorizacion}</h4>{' '}
              </>
            )
          ) : (
            <h2>Nueva autorización</h2>
          )}
        </div>

        {isModoEditar && (
          <Link to={`/autorizaciones/detalle/${idAutorizacion}`} className='text-white mx-2'>
            <button className='btn btn-primary'>
              {' '}
              Ir al detalle <i className='fa-solid fa-arrow-right ms-3 fs-4 '> </i>
            </button>
          </Link>
        )}
      </div>
      <div className='col-12'>
        {isModoEditar && (isLoading || isError) && (
          <CargaInfo
            mensaje={'Recuperando información de la autorización'}
            isError={isError}
            mensajeError={'Ocurrió un error al recuperar los datos de la autorización'}
            errorApi={error}
          />
        )}
      </div>
    </>
  )
}
